import { useEffect, useState } from 'react';
import './LoginCard.css';
import { loginMicrosoft, loginGoogle, checkAuth } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import Modal from '../Modal/Modal';


const LoginCard = () => {
  const navigate = useNavigate();
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });

  const handleLoginMi = () => {
    loginMicrosoft();
  };

  const handleLoginGo = () => {
    loginGoogle();
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    if (error) {
      setErrorModal({ show: true, message: decodeURIComponent(error) });
      window.history.replaceState({}, "", "/login");
    }
  }, []);

  useEffect(() => {
    const verificarSessao = async () => {
      const authData = await checkAuth();
      if (authData.isAuthenticated) {
        navigate('/operador-linha', { replace: true });
      }
    };

    verificarSessao();
  }, [navigate]);


  return (
    <>
      <div className="login-background">

        {/* LEFT SIDE IMAGE */}
        <div className="login-right">

          <div className="right-overlay" />

          <img
            className="login-img"
            src="/images/loginImg.png"
            alt="Painel operacional"
          />

        </div>

        {/* RIGHT SIDE CONTENT */}
        <div className="login-left">

          <div className="login-header">

            <div className="login-badge">
              Plataforma Operacional
            </div>

            <h1 className="login-title">
              Sentinela Telemetria
            </h1>

            <p className="login-description">
              Monitoramento ferroviário em tempo real com
              análise operacional inteligente.
            </p>

          </div>

          <div className="login-actions">

            <button
              className="login-button microsoft"
              onClick={handleLoginMi}
            >
              <div className="logo-wrapper">
                <img
                  src="/images/LoginMicrosoft.png"
                  alt="Microsoft logo"
                />
              </div>

              Continuar com Microsoft
            </button>

            <button
              className="login-button google"
              onClick={handleLoginGo}
            >
              <div className="logo-wrapper">
                <img
                  src="/images/LoginGoogle.png"
                  alt="Google logo"
                />
              </div>

              Continuar com Google
            </button>

          </div>

          <div className="login-footer">
            Sistema operacional ferroviário • Sentinela v1.0
          </div>

        </div>

      </div>

      <Modal
        show={errorModal.show}
        type="error"
        message={errorModal.message}
        onClose={() => setErrorModal({ show: false, message: "" })}
      />
    </>
  );
};

export default LoginCard;
